import type React from 'react';

export const FooterSlots = {
  Socials: ({ children }) => children,
  TopSection: ({ children }) => children,
} as const satisfies Record<string, React.FC<React.PropsWithChildren>>;
